export enum TicketType {
  SingleTicket = 'SingleTicket',
  DayTicket = 'DayTicket',
  ThreeDayTicket = 'ThreeDayTicket',
  ThirtyDays = 'ThirtyDays',
  NinetyDays = 'NinetyDays',
  ThreeHundredSixtyFiveDays = 'ThreeHundredSixtyFiveDays',
}
